export const NOTIFICATION_TYPES = {
  STREAM_CALIBRATION: "Stream calibration in progress",
  CALIBRATION_FAILED: "Failed to Calibrate",
  NO_PERMISSION: "No Permission",
  INFO: "info",
  WARNING: "warning",
  CRITICAL: "critical",
};

export const BUTTON_LABELS = {
  REFRESH: "Refresh",
  CALIBRATE: "Calibrate",
  CANCEL: "Cancel",
  OK: "OK",
};

export const SUBTITLES = {
  STREAM_CALIBRATION: "Licenses and apps cannot be selected for a stream until it is calibrated. Refresh this page to check stream calibration status.",
  STREAM_CALIBRATION_COMPLETE: "The camera stream has been successfully calibrated.",
  CALIBRATION_TIP: "Automatic calibration works best when there is a person in view of the stream.  If there is not a person in view of the stream, manual calibration may be a better option.",
  CALIBRATION_FAILED: "Please try calibrating the camera after some time again.",
  CAMERA_OFFLINE: "Calibration is unavailable because the camera is currently offline. Please bring the camera online and try again.",
  CALIBRATION_IN_PROGRESS_DETAIL: "requires manual calibration, which is currently in progress for this stream. Please click Refresh on the banner to check the status, then try again.",
};

export const TITLES = {
  STREAM_CALIBRATION: "calibration in progress",
  STREAM_CALIBRATION_COMPLETE: "calibration completed",
  CALIBRATION_TIP: "Calibration tip",
  CALIBRATION_FAILED: "calibration failed",
  CAMERA_OFFLINE: "Camera is offline",
  CALIBRATION_IN_PROGRESS_MODAL: "Calibration in progress",
  DEVICE_LIST_CALIBRATION_COMPLETE: "Stream calibration completed",
};

export const MODAL_LABELS = {
  CALIBRATE_STREAM: "Calibrate stream",
};

export const CALIBRATION_MODES = {
  AUTOMATIC: "automatic",
  MANUAL: "manual",
  SKIPPED: "Skipped"
};

export const CALIBRATION_MODE_VALUES = {
  MANUAL: "Manual",
  AUTOMATIC: "Automatic",
};

export const RADIO_LABELS = {
  MANUAL_NO_SNAPSHOT: "Manual (snapshot not available)",
};

export const RADIO_OPTIONS = [
  {
    children: "Automatic",
    value: "Automatic",
    ariaLabel: "radio one",
    disabled: false,
  },
  {
    children: "Manual",
    value: "Manual",
    ariaLabel: "radio three",
    disabled: false,
  },
];

export const CALIBRATE_CONSTNATS = {
  SNAPSHOT_UNAVAILABLE: "Snapshot not available",
  SNAPSHOT_DESC: "Manual calibration needs a snapshot to set scene parameters. Please try again later.",
}

export const DELETE_CAMERA_CONSTANTS = {
  DELETE_CAMERA: "Delete Camera",
  DELETE_CAMERA_MSG: "Failed to check subscribed apps for this camera. Please try again.",
  DELETE_CAMERA_WARNING_MSG:
    "If a camera is deleted, all configurations associated with computer vision apps will be deleted and the camera will no longer be subscribed to any CV licenses or CV Apps. Therefore the camera will no longer generate events, alerts, statistics, or video evidence.",
  CAMERA_CVAPP_MSG: "You must unsubscribe to all apps running on this camera in order to delete.",
  CONFIRM_DELETE: "Are you sure you’d like to delete this camera?",
};